import { AfterContentInit, Component, ElementRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { of } from 'rxjs';
import { finalize, switchMap, tap } from 'rxjs/operators';

import { PasswordInput } from '@app/models';
import { ErrorHandlerService, NotyService, UserService } from '@app/services';
import { ConfirmOtpModalService } from '@app/shared';
import { CredentialsService } from '@app/core';

export type ModalResult = void;
// export interface ModalPublicProperties {}

@Component({
  selector: 'app-edit-password-modal',
  templateUrl: './edit-password-modal.component.html',
  styleUrls: ['./edit-password-modal.component.scss'],
  standalone: false
})
export class EditPasswordModalComponent implements AfterContentInit {
  form!: UntypedFormGroup;
  isLoading = false;
  @ViewChild('passwordInput', { static: false }) private passwordInput: ElementRef<HTMLInputElement>;

  constructor(
    public modal: NgbActiveModal,
    public translateService: TranslateService,
    private formBuilder: UntypedFormBuilder,
    private notyService: NotyService,
    private errorHandlerService: ErrorHandlerService,
    private userService: UserService,
    private credentialsService: CredentialsService,
    private confirmOtpModalService: ConfirmOtpModalService
  ) {
    this.form = this.formBuilder.group({
      newPasswordInfo: this.formBuilder.group({ current: '', new: '', new_confirmation: '' } as PasswordInput),
      otp: ''
    });
  }

  ngAfterContentInit() {
    setTimeout(() => this.passwordInput.nativeElement.focus());
  }

  updatePassword() {
    this.isLoading = true;
    this.form.markAllAsTouched();

    (this.credentialsService.credentials.mfa.length > 0 ? this.confirmOtpModalService.open() : of(null))
      .pipe(
        tap(otp => this.form.get('otp').setValue(otp)),
        switchMap(() => this.userService.updateCurrentUserPassword(this.form.value)),
        finalize(() => (this.isLoading = false))
      )
      .subscribe({
        next: hasChangedPassword => {
          if (hasChangedPassword) {
            this.notyService.success(this.translateService.instant('success_change_password'));
            this.modal.close();
          } else {
            this.notyService.error(this.translateService.instant('error_change_password'));
          }
        },
        error: error => this.errorHandlerService.handleValidation(this.form, error)
      });
  }
}
